// GlobalStyles.js
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  body {
    background-color: ${(props) => props.theme.body};
    color: ${(props) => props.theme.text};
    font-family: ${(props) => props.theme.fontFamily};
    font-size: ${(props) => props.theme.fontSize};
    transition: all 0.25s linear;

    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
    margin: 0;
    padding: 0;
  }

`;

export const Stack = styled.div`
  display: flex;
  flex-direction: ${(props) => props.$direction || 'row'};
  justify-content: ${(props) => props.$justifyContent || 'flex-start'};
  align-items: ${(props) => props.$alignItems || 'flex-start'};
  gap: ${(props) => props.$spacing};
  flex-wrap: ${(props) => props.$wrap};
  width: ${(props) => props.$width || 'auto'};
  height: ${(props) => props.$height || 'auto'};

  overflow-x: ${(props) => props.$overflowX};
  overflow-y: ${(props) => props.$overflowY};
  overflow: ${(props) => props.$overflow};

  margin: ${(props) => props.$margin};
  margin-top: ${(props) => props.$marginTop};
  margin-bottom: ${(props) => props.$marginBottom};
  margin-left: ${(props) => props.$marginLeft};
  margin-right: ${(props) => props.$marginRight};

  padding: ${(props) => props.$padding};
  padding-top: ${(props) => props.$paddingTop};
  padding-bottom: ${(props) => props.$paddingBottom};
  padding-left: ${(props) => props.$paddingLeft};
  padding-right: ${(props) => props.$paddingRight};
  background-color: ${(props) => props.$backgroundColor};
  border: ${(props) => props.$border};
  border-radius: ${(props) => props.$borderRadius};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns || 12}, 1fr);
  grid-gap: ${(props) => props.$spacing || '16px'};
  width: 100%;
`;

export const GridItem = styled.div`
  grid-column: span ${(props) => props.$col || 1}; /* Span the number of columns specified */
  @media (max-width: 600px) {
    grid-column: span ${(props) => props.$sm || 12}; /* Small screens: Default span full width */
  }
  @media (min-width: 600px) and (max-width: 900px) {
    grid-column: span ${(props) => props.$md || props.$col || 6}; /* Medium screens */
  }
  @media (min-width: 900px) {
    grid-column: span ${(props) => props.$lg || props.$col}; /* Large screens */
  }
`;

export const Typography = styled.p`
  font-size: ${(props) => getFontSize(props.$variant)};
  font-family: ${(props) => props.$font || 'Regular'};
  font-weight: ${(props) => props.$fontWeight || 'normal'};
  text-align: ${(props) => props.$align || 'left'};
  color: ${(props) => props.$color || 'inherit'};
  margin: ${(props) => props.$margin || '0'};
  line-height: ${(props) => props.$lineHeight || 'normal'};
  text-align: ${(props) => props.$align || 'left'};
  white-space: ${(props) => props.$whiteSpace || 'normal'};
  width: ${(props) => props.$width || 'auto'};
`;

export const Button = styled.button`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 12px;
  color: ${(props) => props.$color || props.theme.white};
  margin: ${(props) => props.$margin || '0'};
  font-family: 'Bold';
  font-size: 18px;
  background-color: ${(props) => props.$backgroundColor || props.theme.primary?.main};
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:active {
    scale: 0.98;
`;

const getFontSize = (variant) => {
  switch (variant) {
    case 'h1':
      return '34px';
    case 'h2':
      return '28px';
    case 'h3':
      return '24px';
    case 'h4':
      return '22px';
    case 'h5':
      return '20px';
    case 'h6':
      return '20px';
    case 'subtitle1':
      return '18px';
    case 'subtitle2':
      return '16px';
    case 'body1':
      return '14px';
    case 'body2':
      return '12px';
    case 'caption':
      return '11px';
    case 'button':
      return '12px';
    case 'overline':
      return '11px';
    default:
      return '14px';
  }
};

